export interface JobRecord {
  id: number;
  name: string;
  action: string;
  start_time: Date;
  end_time?: Date;
  success: boolean;
  progress: number;
  admin_id: number;
  admin_name?: string;
  summary?: string;
}

export class JobTypes {
  static SEND_COUPON_EMAIL_REMINDER = "SEND_COUPON_EMAIL_REMINDER";
  static FREE_UNUSED_COUPONS = "FREE_UNUSED_COUPONS";
  static DOWNLOAD_INVOICES_BACKGROUND = "DOWNLOAD_INVOICES_BACKGROUND";
  static BULK_DOWNLOAD_SHIPMENTS_SHIPROCKET_TEMPLATE_BACKGROUND =
    "BULK_DOWNLOAD_SHIPMENTS_SHIPROCKET_TEMPLATE_BACKGROUND";
  static BULK_DOWNLOAD_SHIPMENTS_SHIPMOZO_TEMPLATE_BACKGROUND =
    "BULK_DOWNLOAD_SHIPMENTS_SHIPMOZO_TEMPLATE_BACKGROUND";
  static BULK_DOWNLOAD_SHIPMENTS_REPORT_TEMPLATE_BACKGROUND =
    "BULK_DOWNLOAD_SHIPMENTS_REPORT_TEMPLATE_BACKGROUND";
  static BULK_UPLOAD_SHIPMENT_PACK_LINES_BACKGROUND =
    "BULK_UPLOAD_SHIPMENT_PACK_LINES_BACKGROUND";
  static BULK_UPLOAD_SHIPMENT_ITEM_LINES_BACKGROUND =
    "BULK_UPLOAD_SHIPMENT_ITEM_LINES_BACKGROUND";
}
